import FrontendLayout from "../layouts/Frontend/FrontendLayout";
import HomeScreen from "../layouts/Frontend/Home/Homescree";
import SerchDocters from "../layouts/Frontend/SerchDocters/SerchDocters";
import SerchHospital from "../layouts/Frontend/SerchDocters/SerchHospital";
import RegisterScreen from "../layouts/Frontend/Register/RegisterScreen";
import LoginScreen from "../layouts/Frontend/Login/LoginScreen";
import ArticlesReviews from "../layouts/Frontend/Home/Components/ArticlesReviews";
import ArticalesList from "../layouts/Frontend/Articeals/Articaleslist";
import ServiceDetail from "../layouts/Frontend/Home/Components/ServiceDetail";
import AboutUs from "../layouts/Frontend/About-Us/aboutus";
import NotFound from "../components/NotFound";
import DoctorsDetailsView from "../layouts/IndividualDoctor/DoctorsDetailsView";
// import HospitalDetailsView from "../layouts/IndividualHospital/HospitalDetailsView";
import Anesthesiology from "../layouts/Frontend/Home/Components/ArticlesComponents/Anesthesiology";
import Dermatology from "../layouts/Frontend/Home/Components/ArticlesComponents/Dermatology";
import DiagnosticRadiology from "../layouts/Frontend/Home/Components/ArticlesComponents/DiagnosticRadiology";
import EmergencyMedicine from "../layouts/Frontend/Home/Components/ArticlesComponents/EmergencyMedicine";
import FamilyMedicine from "../layouts/Frontend/Home/Components/ArticlesComponents/FamilyMedicine";
import Shop from "../layouts/Frontend/Pharmacy/Shop";
import PharmacyList from "../layouts/Frontend/Pharmacy/PharmacyList";
import PharmacyDetailes from "../layouts/Frontend/Pharmacy/PharmacyDetailes";
import TermsandConditions from "../layouts/Frontend/TermsandConditions";
import PrivacyPolicy from "../layouts/Frontend/PrivacyPolicy";
import RefundReturns from "../layouts/Frontend/RefundReturns";
import Contactus from "../layouts/Frontend/Contactus";
import PackageDetails from "../layouts/Frontend/Packages/PackageDetails";
import AllPackages from "../layouts/Frontend/Packages/AllPackages";
import CheckoutPage from "../layouts/IndividualDoctor/Components/CheckoutPage";
import DoctorLayout from "../layouts/Doctor/DoctorLayout";
import Demopage from "../layouts/Doctor/Demo";
import OAuthCallback from "../layouts/OAuthCallback";
import PolicyPage from "../layouts/Frontend/Policy/policypage";
import JobsPage from "../layouts/Frontend/Jobs/JobsPage";
import BloodBanksPage from "../layouts/Frontend/BloodBanks/BloodBanksPage";
import ShippingPolicy from "../layouts/Frontend/ShippingPolicy";
import { getPlatform } from "../Uitiles/platformDetector";
import SplashScreen from "../layouts/Frontend/Home/splashscreen";
import IntroScreens from "../layouts/Frontend/Home/IntroScreens";
import MobileLoginScreen from "../layouts/Frontend/Login/MobileLoginScreen";
import MobileRegisterScreen from "../layouts/Frontend/Register/MobileRegisterScreen";
import ForgetPassword from "../layouts/Frontend/Login/ForgetPassword";
import HomeWithIntro from "../layouts/Frontend/Home/HomeWithIntro";
import { useState, useEffect } from "react";
import ComponentDemo from "../layouts/MainCompontes/ComponentDemo";
import DashboardExample from "../layouts/MainCompontes/DashboardExample";
import CheckLogin from "../layouts/CheckLogin";

// Platform-aware Home Component using async detection
const PlatformAwareHome = () => {
  const [platformInfo, setPlatformInfo] = useState(null);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const detectPlatform = async () => {
      try {
        const info = await getPlatform();
        console.log("Platform Info (JSON):", info);
        setPlatformInfo(info);
        // Hide splash screen after platform detection completes
        setShowSplash(false);
      } catch (error) {
        console.error("Error detecting platform:", error);
        // Fallback to web platform
        setPlatformInfo({ os: "web", platform: "web" });
        setShowSplash(false);
      }
    };

    detectPlatform();
  }, []);

  // Show splash screen while detecting platform
  if (showSplash || !platformInfo) {
    return <SplashScreen />;
  }

  // Check if mobile platform
  const isMobile = platformInfo && (platformInfo.os === "android" || platformInfo.os === "ios");

  // Show splash screen for mobile platforms
  if (isMobile) {
    return <SplashScreen />;
  }

  // Show HomeScreen for desktop/web
  return (
    <FrontendLayout>
      <HomeScreen />
    </FrontendLayout>
  );
};

const frontendRoutes = [
  { path: "/", element: <PlatformAwareHome /> },
  { path: "/search-doctors", element: <FrontendLayout><SerchDocters /></FrontendLayout> },
  { path: "/search-hospitals", element: <FrontendLayout><SerchHospital /></FrontendLayout> },
  { path: "/authentication", element: <FrontendLayout><RegisterScreen /></FrontendLayout> },
  { path: "/login", element: <FrontendLayout><LoginScreen /></FrontendLayout> },
  { path: "/demopage", element: <DoctorLayout><Demopage /></DoctorLayout> },
  { path: "/doctor/:name/:id", element: <FrontendLayout><DoctorsDetailsView /></FrontendLayout> },
  { path: "/hospital/:name/:id", element: <FrontendLayout><DoctorsDetailsView /></FrontendLayout> },
  { path: "/articles", element: <FrontendLayout><ArticalesList /></FrontendLayout> },
  { path: "/articles/:slug/:id", element: <FrontendLayout><ArticlesReviews /></FrontendLayout> },
  { path: "/anesthesiology", element: <FrontendLayout><Anesthesiology /></FrontendLayout> },
  { path: "/dermatology", element: <FrontendLayout><Dermatology /></FrontendLayout> },
  { path: "/diagnosticradiology", element: <FrontendLayout><DiagnosticRadiology /></FrontendLayout> },
  { path: "/emergencymedicine", element: <FrontendLayout><EmergencyMedicine /></FrontendLayout> },
  { path: "/familymedicine", element: <FrontendLayout><FamilyMedicine /></FrontendLayout> },
  { path: "/shop", element: <FrontendLayout><Shop /></FrontendLayout> },
  { path: "/pharmacylist", element: <FrontendLayout><PharmacyList /></FrontendLayout> },
  { path: "/pharmacy", element: <FrontendLayout><PharmacyDetailes /></FrontendLayout> },
  { path: "/about-us", element: <FrontendLayout><AboutUs /></FrontendLayout> },
  { path: "/terms-and-conditions", element: <FrontendLayout><TermsandConditions /></FrontendLayout> },
  { path: "/shipping_policy", element: <FrontendLayout><ShippingPolicy /></FrontendLayout> },
  { path: "/privacy-policy", element: <FrontendLayout><PrivacyPolicy /></FrontendLayout> },
  { path: "/refund_returns", element: <FrontendLayout><RefundReturns /></FrontendLayout> },
  { path: "/contact-us", element: <FrontendLayout><Contactus /></FrontendLayout> },
  { path: "/services/:slug", element: <FrontendLayout><ServiceDetail /></FrontendLayout> },
  { path: "/package/:packageId", element: <FrontendLayout><PackageDetails /></FrontendLayout> },
  { path: "/packages", element: <FrontendLayout><AllPackages /></FrontendLayout> },
  { path: "/checkout/:doctorId", element: <FrontendLayout><CheckoutPage /></FrontendLayout> },
  { path: "/oauth-callback", element: <OAuthCallback /> },
  { path: "/policy", element: <FrontendLayout><PolicyPage /></FrontendLayout> },
  { path: "/jobs", element: <FrontendLayout><JobsPage /></FrontendLayout> },
  { path: "/blood-banks", element: <FrontendLayout><BloodBanksPage /></FrontendLayout> },
  { path: "/component-demo", element: <ComponentDemo /> },
  { path: "/dashboard-example", element: <DashboardExample /> },

  { path: "*", element: <FrontendLayout><NotFound /></FrontendLayout> },


  // check login 
  { path: "/checklogin", element: <FrontendLayout><CheckLogin /></FrontendLayout> },


  // mobile routes
  { path: "/mobile/login", element: <MobileLoginScreen /> },
  { path: "/mobile/forgot-password", element: <ForgetPassword /> },
  { path: "/SplashScreen", element: <SplashScreen /> },
  { path: "/mobile/IntroScreens", element: <IntroScreens /> },
  { path: "/mobile/authentication", element: <MobileRegisterScreen /> },
  { path: "/mobile/home", element: <FrontendLayout><HomeScreen /></FrontendLayout> },
];

export default frontendRoutes;
